import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  wrapper: {
    backgroundColor: '#F9F9F9',
    padding: '110px 0',
  },
  container: {
    margin: '0 auto',
    width: '100%',
    maxWidth: '1220px',
    '@media (max-width: 600px)': {
      boxSizing: 'border-box',
      padding: '0 15px',
    },
  },
  sectionOne: {
    paddingBottom: '61px',
    borderBottom: '1px solid rgba(78, 78, 78, 0.5)',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '120px',
    '@media (max-width: 600px)': {
      gridGap: '30px',
      gridTemplateColumns: '1fr',
    },
  },
  sectionOneLeft: {
    '& h2': {
      color: '#E10A0A',
      marginBottom: '10px',
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '41px',
    },
    '& p': {
      color: '#2D2D2D',
      fontSize: '16px',
      lineHeight: '1.4',
    },
  },
  sectionOneRight: {
    position: 'relative',
    paddingLeft: '75px',
    '& p': {
      padding: 0,
      margin: 0,
      '&:first-child': {
        marginTop: '18px',
      },
      '&:nth-child(2)': {
        marginTop: '36px',
      },
      '&:nth-child(3)': {
        marginTop: '36px',
        marginBottom: '36px',
      },
    },
  },
  sectionOneRightImg: {
    position: 'absolute',
    left: 0,
    top: 0,
    mixBlendMode: 'multiply',
  },
  sectionTwo: {
    paddingTop: '61px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '120px',
    '@media (max-width: 600px)': {
      gridGap: '30px',
      gridTemplateColumns: '1fr',
    },
  },
  sectionTwoLeftImg: {
    mixBlendMode: 'multiply',
    width: '487px',
    height: '167px',
    '@media (max-width: 600px)': {
      width: '290px',
      height: 'auto',
    },
  },
  sectionTwoRight: {
    '& h2': {
      color: '#512698',
    },
    '& a': {
      color: '#512698',
      textDecoration: 'underline',
      fontWeight: 'bold',
    },
    '& p': {
      color: '#2D2D2D',
      fontSize: '16px',
      lineHeight: '1.4',
    },
  },
}))

const VelocityPromo = () => {
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <div className={classes.sectionOne}>
          <div className={classes.sectionOneLeft}>
            <h2>Earn Points for your business</h2>
            <p>
              As a Virgin Australia Business Flyer, each time you book car hire with Thrifty Car
              Rental, your business will earn Points based on the business’s membership Tier Status.
              The higher the Tier, the higher the Points.
            </p>
          </div>
          <div className={classes.sectionOneRight}>
            <img
              className={classes.sectionOneRightImg}
              src="/themes/thrifty/assets/images/velocityimg1.png?5"
            />
            <div>
              <p>Tier 1 = 1 Point per $1 spent*</p>
              <p>Tier 2 = 1.5 Points per $1 spent*</p>
              <p>Tier 3 = 2 Points per $1 spent*</p>
            </div>
            <div style={{ fontSize: '14px', color: '#2D2D2D', fontWeight: 300 }}>
              *AUD ex GST of car rental
            </div>
          </div>
        </div>
        <div className={classes.sectionTwo}>
          <div className={classes.sectionTwoLeft}>
            <img
              className={classes.sectionTwoLeftImg}
              src="/themes/thrifty/assets/images/velocityimg2.png?5"
            />
          </div>
          <div className={classes.sectionTwoRight}>
            <h2>Earn Points for the driver</h2>
            <p>
              Plus, earn Points as the driver when you are a Velocity Frequent Flyer member. As a
              Red member you will earn 3 Points per $1 spent; as a Silver member you will earn 4.5
              Points per $1 spent; as a Gold member you will earn 5.25 Points per $1 spent; and as a
              Platinum member, you will earn 6 Points per $1 spent.* Not already a Velocity member?
              &nbsp;
              <a href="https://join.velocityfrequentflyer.com/" target="_blank" rel="noreferrer">
                Join now.
              </a>
            </p>
            <div style={{ fontSize: '14px', color: '#2D2D2D', fontWeight: 300 }}>
              *AUD ex GST of car rental
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VelocityPromo
